export default "__VITE_ASSET__RD19ofIs__"